async function inpostPayBinding() {
  try {
    const response = await fetch(`/?wc-ajax=inpost_pay_bind`, {
      method: "GET",
    });

    if (!response.ok) {
      throw new Error(`Błąd sieci: ${response.status}`);
    }
  } catch (error) {
    console.error("Wystąpił błąd:", error);
  }
}

export { inpostPayBinding };
